import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import deepmerge from 'deepmerge';

import SelectField from '../../../../../common/select_field';
import { getOrderStatusOptions } from '../../../../../common/utils/order_utils';
import { getAllPodsState } from '../../../../../../features/pod/get_all_pods';

const Filters = ({ queryParams, setQueryParams }) => {
    const [orderStatus, setOrderStatus] = useState(queryParams?.status || 'ALL');
    const [pod, setPod] = useState(queryParams?.queryFilter || 'none');

    const getAllPods = useSelector(getAllPodsState);

    const onSelectPodChange = (event) => {
        setPod(event.target.value);

        if (event.target.value === 'none') {
            setQueryParams(prevState => deepmerge(prevState, { podId: '' }));
        } else {
            setQueryParams(prevState => deepmerge(prevState, { podId: event.target.value }));
        }
    };

    const onSelectOrderStatusChange = (event) => {
        setOrderStatus(event.target.value);
        setQueryParams(prevState => deepmerge(prevState, { status: event.target.value }));
    };

    return (
        <Card variant="outlined" sx={ { mb: 4, width: '100%', backgroundColor: 'slate.50' } }>
            <CardContent sx={ { p: 3, pb: '24px !important' } }>


                <Box sx={ { display: 'flex', alignItems: 'center', mb: 3, gap: 1 } }>
                    <FilterListIcon color="action" fontSize="small"/>
                    <Typography variant="overline" color="text.secondary"
                                sx={ { fontSize: '0.85rem', fontWeight: 600 } }>
                        Filtry zakupów stacjonarnych
                    </Typography>
                </Box>

                <Grid container spacing={ 3 } alignItems="flex-start">
                    <Grid item xs={ 12 } md={ 4 }>
                        <SelectField
                            size="small"
                            fullWidth
                            label="Status"
                            value={ orderStatus }
                            onChange={ onSelectOrderStatusChange }
                            options={ [{ value: 'ALL', label: 'Wszystkie' }, ...getOrderStatusOptions] }
                        />
                    </Grid>
                    <Grid item xs={ 12 } md={ 8 }>
                        <SelectField
                            size="small"
                            fullWidth
                            label="Wybierz punkt sprzedaży"
                            value={ pod }
                            onChange={ onSelectPodChange }
                            options={ [
                                { value: 'none', label: 'Wszystkie punkty' },
                                ...(getAllPods?.data?.map(pod => ({
                                    value: pod?.id,
                                    label: `${ pod?.indoorPartner?.name } (${ pod?.description }) - ${ pod?.device?.serviceId || 'brak urządzenia' }`
                                })) || [])
                            ] }
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default Filters;